import { useAtomValue } from "jotai";
import { useKrwRate } from "#/hooks/use-krw-rate";
import { formatKrw } from "#/lib/formatters";
import { cn } from "#/lib/utils";
import { localeAtom } from "#/stores/locale-store";

type Props = {
	usd: string | number | null | undefined;
	className?: string;
	inheritColor?: boolean;
	inline?: boolean;
	parens?: boolean;
};

export function KrwSubtext({
	usd,
	className,
	inheritColor,
	inline,
	parens,
}: Props) {
	const locale = useAtomValue(localeAtom);
	const { data: rate } = useKrwRate();

	if (locale !== "ko") return null;
	const text = formatKrw(usd, rate);
	if (!text) return null;

	return (
		<span
			className={cn(
				inline
					? "ml-1.5 text-caption1"
					: "block text-caption1",
				inheritColor ? "opacity-70" : "text-muted-foreground",
				className,
			)}
		>
			{parens ? `(${text})` : text}
		</span>
	);
}

export function useIsKoreanLocale() {
	return useAtomValue(localeAtom) === "ko";
}
